module.exports = __webpack_public_path__ + "img/preview-hybrid.884526c5.png";